const sleep = (duration) => (
  (...args) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(...args)
      }, duration)
    })
  }
)

export default sleep


// WEBPACK FOOTER //
// ./src/sleep.js